import { inject } from 'vue';
import { route } from './plugin';

export const ziggyKey = Symbol.for('ziggy');

export default function(): typeof route {
  return inject<typeof route>(ziggyKey)!;
}
